export const pluginFlags = Object.freeze({
  assets: __PLUGIN_ASSETS__,
  contact: __PLUGIN_CONTACT__,
  mailinglist: __PLUGIN_MAILING_LIST__,
  projects: __PLUGIN_PROJECTS__,
});
